import React from "react";
import {
    SectionCard,
    PaginationBar,
    inputClass,
    checkboxClass,
    primaryButtonClass,
    saveButtonClass,
} from "../adminShared";

const SubscriptionsTab = ({
    subscriptionSearch,
    setSubscriptionSearch,
    filteredSubscriptions,
    subscriptionDrafts,
    setSubscriptionDrafts,
    accounts,
    users,
    userMap,
    working,
    saveSubscription,
    setSubscriptionDialogOpen,
    subscriptionsPagination,
    goToSubscriptionsPage,
}) => (
    <div className="flex flex-col gap-6">
        <SectionCard
            title="Create subscription"
            description="Assign a company or individual subscription and set its expiry."
            right={
                <button
                    type="button"
                    className={`${primaryButtonClass} px-4`}
                    onClick={() => setSubscriptionDialogOpen(true)}
                >
                    Create subscription
                </button>
            }
        />

        <SectionCard
            title="Manage subscriptions"
            description="Edit type, linked entity, expiry date, and activation state."
            right={
                <div className="w-full sm:w-72">
                    <input
                        className={inputClass}
                        value={subscriptionSearch}
                        onChange={(e) => setSubscriptionSearch(e.target.value)}
                        placeholder="Search subscriptions..."
                    />
                </div>
            }
        >
            <div className="overflow-x-auto rounded-xl border border-slate-200">
                <table className="min-w-full text-left text-sm">
                        <thead className="bg-slate-50 text-slate-600">
                            <tr>
                                <th className="px-3 py-2">Type</th>
                                <th className="px-3 py-2">Linked record</th>
                                <th className="px-3 py-2">Expires</th>
                                <th className="px-3 py-2">Status</th>
                                <th className="px-3 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200 bg-white">
                            {filteredSubscriptions.map((sub) => {
                            const draft = subscriptionDrafts[sub.subscription_id] || {};
                            const showCompany = draft.subscription_type === "company";

                            return (
                                <tr key={sub.subscription_id} className="align-top">
                                    <td className="px-3 py-2 min-w-[140px]">
                                        <select
                                            className={inputClass}
                                            value={draft.subscription_type || "company"}
                                            onChange={(e) =>
                                                setSubscriptionDrafts((prev) => ({
                                                    ...prev,
                                                    [sub.subscription_id]: {
                                                        ...prev[sub.subscription_id],
                                                        subscription_type: e.target.value,
                                                        user_id:
                                                            e.target.value === "individual"
                                                                ? prev[sub.subscription_id]?.user_id || ""
                                                                : "",
                                                        account_id:
                                                            e.target.value === "company"
                                                                ? prev[sub.subscription_id]?.account_id || ""
                                                                : "",
                                                    },
                                                }))
                                            }
                                        >
                                            <option value="company">Company</option>
                                            <option value="individual">Individual</option>
                                        </select>
                                    </td>

                                    <td className="px-3 py-2 min-w-[240px]">
                                        {showCompany ? (
                                            <select
                                                className={inputClass}
                                                value={draft.account_id || ""}
                                                onChange={(e) =>
                                                    setSubscriptionDrafts((prev) => ({
                                                        ...prev,
                                                        [sub.subscription_id]: {
                                                            ...prev[sub.subscription_id],
                                                            account_id: e.target.value,
                                                        },
                                                    }))
                                                }
                                            >
                                                <option value="">Select company</option>
                                                {accounts.map((account) => (
                                                    <option key={account.account_id} value={account.account_id}>
                                                        {account.name}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : (
                                            <select
                                                className={inputClass}
                                                value={draft.user_id || ""}
                                                onChange={(e) =>
                                                    setSubscriptionDrafts((prev) => ({
                                                        ...prev,
                                                        [sub.subscription_id]: {
                                                            ...prev[sub.subscription_id],
                                                            user_id: e.target.value,
                                                        },
                                                    }))
                                                }
                                            >
                                                <option value="">Select user</option>
                                                {users.map((user) => (
                                                    <option key={user.user_id} value={user.user_id}>
                                                        {userMap[user.user_id]}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </td>

                                    <td className="px-3 py-2 min-w-[180px]">
                                        <input
                                            type="datetime-local"
                                            className={inputClass}
                                            value={draft.expires_at || ""}
                                            onChange={(e) =>
                                                setSubscriptionDrafts((prev) => ({
                                                    ...prev,
                                                    [sub.subscription_id]: {
                                                        ...prev[sub.subscription_id],
                                                        expires_at: e.target.value,
                                                    },
                                                }))
                                            }
                                        />
                                    </td>

                                    <td className="px-3 py-2 min-w-[120px]">
                                        <label className="flex h-10 items-center gap-2 rounded-xl border border-slate-200 px-3">
                                            <input
                                                type="checkbox"
                                                className={checkboxClass}
                                                aria-label="Subscription status"
                                                checked={!!draft.is_active}
                                                onChange={(e) =>
                                                    setSubscriptionDrafts((prev) => ({
                                                        ...prev,
                                                        [sub.subscription_id]: {
                                                            ...prev[sub.subscription_id],
                                                            is_active: e.target.checked,
                                                        },
                                                    }))
                                                }
                                            />
                                        </label>
                                    </td>

                                    <td className="px-3 py-2 min-w-[112px]">
                                        <div className="flex items-center gap-2">
                                            <button
                                                className={saveButtonClass}
                                                onClick={() => saveSubscription(sub.subscription_id)}
                                                disabled={working}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}

                        {filteredSubscriptions.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="px-4 py-8 text-center text-slate-500">
                                    No subscriptions found.
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
            <PaginationBar
                page={subscriptionsPagination.page}
                totalPages={subscriptionsPagination.total_pages}
                totalCount={subscriptionsPagination.total_count}
                totalLabel="subscriptions"
                onPrevious={() => goToSubscriptionsPage(subscriptionsPagination.page - 1)}
                onNext={() => goToSubscriptionsPage(subscriptionsPagination.page + 1)}
                disabled={working}
            />
        </SectionCard>
    </div>
);

export default SubscriptionsTab;
